export default {"src":"/_next/static/media/servicesFill.ce7d400f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};